module.exports = __webpack_public_path__ + "static/media/map.82e5cd01.svg";